module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "overwrite-left"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    },
    slot: "overwrite-left"
  }, [_vm._v(" 关闭")]), _vm._v("\n    提交免备案域名\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "8em"
    }
  }, [_c('popup-picker', {
    attrs: {
      "title": "类型",
      "data": _vm.type,
      "columns": 1
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "业务",
      "show-name": true,
      "data": _vm.list,
      "columns": 1
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "label-width": "6.5em",
      "title": "域名",
      "placeholder": "请输入域名"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "label-width": "12em",
      "title": "要取消重定向的资源文件",
      "placeholder": "默认不填"
    },
    model: {
      value: (_vm.flash_url),
      callback: function($$v) {
        _vm.flash_url = $$v
      },
      expression: "flash_url"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "0.2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-warn-master margin-bottom-20 domain-list"
  }, [_c('p', [_vm._v("1：针对国内网站必须备案才可访问的问题，阿贝云推出了独创的免备案服务，您的域名可以暂时不备案，直接使用。")]), _vm._v(" "), _c('p', [_vm._v("2：由于该服务采用的是海外线路，在访问速度和稳定性上比起国内线路还是要差一些，建议您把域名备案后使用国内线路。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e73fc92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/addfreebeian.vue
// module id = Shpe
// module chunks = 1